import Vue from 'vue';
import Vuex from 'vuex'
import VueRouter from 'vue-router';
import App from './app.vue';
import './styles/common.css';
import Element from 'element-ui';
import ECharts from 'vue-echarts';
import 'element-ui/lib/theme-chalk/index.css'
import VuResource from 'vue-resource'
import store from './vuex/service/store'
import walden from './components/echarts-walden.json'
import {sso, ssoWeb} from './util/SSOUtil'
import axios from 'axios';

// 导航模块票
import home from './components/home.vue'
import baselineRepair from './views/baselineRepair.vue'
import terminalRepairTips from './views/terminalIllegal.vue'
import moaInstallForMac from './views/moaInstallForMac.vue'
import moaInstallForWin from './views/moaInstallForWin.vue'
import dataLeakInstallForWin from './views/dataLeakInstallForWin.vue'
import dataLeakInstallForMac from './views/dataLeakInstallForMac.vue'
import saimenInstallForWin from './views/saimenInstallForWin.vue'
import saimenInstallForMac from './views/saimenInstallForMac.vue'
import whiteApply from './views/whiteApply.vue'
// import windowRepairUnstart from './views/windowRepairUnstart.vue'
// import macRepairUnstart from './views/macRepairUnstart.vue'
import moaUninstall from './views/moaUninstall.vue'
import verifyMoaIsInstall from './views/moaUninstallURL/verifyMoaIsInstall.vue'
import moaVersionView from './views/moaUninstallURL/moaVersionView.vue'
import macOS_FAQ from './views/macOS_FAQ.vue'
import windows_FAQ from './views/windows_FAQ.vue'
import other_FAQ from './views/other_FAQ.vue'
import userCertApply from './views/userCertApply.vue'

// 登录认证
import cb from './components/callback.vue'
import addItem from "./views/addItem";
import editorItem from "./views/editorItem";
import templateHtml from "./views/templateHtml";
import updateDocument from "./views/updateDocument";
import deleteItem from "./views/deleteItem";
import updateItem from "./views/updateItem";
import addLangIndex from "./views/addLangIndex";
import ai from "./views/ai";

// 报表导航
// import workerState from './views/report/workerState.vue'
// import deploy from './views/report/deploy.vue'

Vue.use(Element);
Vue.use(VueRouter);
Vue.use(VuResource);
Vue.use(Vuex);

// 开启debug模式
Vue.config.debug = true;

//echart
ECharts.registerTheme('walden', walden);
Vue.component('chart', ECharts);

const routers = new VueRouter({
    routes: [
        {path: '/', redirect: 'terminalRepairTips', component: terminalRepairTips},
        {path: '/home', name: 'home', component: home},
        {path: '/terminalRepairTips', name: 'terminalRepairTips', component: terminalRepairTips},
        {path: '/moaUninstall', name: 'moaUninstall', component: moaUninstall},
        // {path: '/windowRepairUnstart', name: 'windowRepairUnstart', component: windowRepairUnstart},
        // {path: '/macRepairUnstart', name: 'macRepairUnstart', component: macRepairUnstart},
        {path: '/verifyMoaIsInstall', name: 'verifyMoaIsInstall', component: verifyMoaIsInstall},
        {path: '/moaVersionView', name: 'moaVersionView', component: moaVersionView},
        {path: '/baselineRepair', name: 'baselineRepair', component: baselineRepair},
        {path: '/callback', name: 'cb', component: cb},
        {path: '/moaInstallForWin', component: moaInstallForWin, name: 'Win安装方法'},
        {path: '/moaInstallForMac', component: moaInstallForMac, name: 'Mac安装方法'},
        {path: '/dataLeakInstallForWin', component: dataLeakInstallForWin, name: 'Win安装方法'},
        {path: '/dataLeakInstallForMac', component: dataLeakInstallForMac, name: 'Mac安装方法'},
        {path: '/saimenInstallForWin', component: saimenInstallForWin, name: 'Win安装方法'},
        {path: '/saimenInstallForMac', component: saimenInstallForMac, name: 'Mac安装方法'},
        {path: '/macOS_FAQ', component: macOS_FAQ, name: 'moaOS常见问题'},
        {path: '/windows_FAQ', component: windows_FAQ, name: 'windows常见问题'},
        {path: '/whiteApply', component: whiteApply, name: '临时白名单申请'},
        {path: '/other_FAQ', component: other_FAQ, name: '其他常见问题'},
        //新建待删除
        {path: '/templateHtml', name: 'template', component: templateHtml},
        {path: '/addItem', name: 'addItem', component: addItem},
        {path: '/editorItem', name: 'editorItem', component: editorItem},
        {path: '/updateDocument', name: 'update', component: updateDocument},
        {path: '/updateItem', name: 'updateItem', component: updateItem},
        {path: '/deleteItem', name: 'delete', component: deleteItem},
        {path: '/whiteApply', name: 'whiteApply', component: whiteApply},
        {path: '/addLangIndex', name: 'addLangIndex', component: addLangIndex},
        // {path: '/userCertApply', name: 'userCertApply', component: userCertApply},
        {path: '/ai', name: 'ai', component: ai},
    ]
});

ssoWeb
    .login()
    .then((ssoid) => {
        if (ssoid && typeof ssoid === 'string') {
            sso.setSsoid(ssoid);
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.defaults.headers.common['access-token'] = ssoid;
            axios.defaults.headers.common['client-id'] = sso.clientId;
            new Vue({
                router: routers,
                store: store,
                render: h => h(App)
            }).$mount('#app');
        }
    });



// WEBPACK FOOTER //
// ./src/main.js